import React from "react";
import { CandlestickChart, Printer } from "lucide-react";

export const DEFAULT_RULES = `Art. 1 – Organizzatore e oggetto
La Trading Cup è il campionato mensile di trading organizzato da RaeinExchange. I partecipanti si sfidano sul rendimento ottenuto dal proprio conto di trading nel corso di ogni mese solare.

Art. 2 – Requisiti di partecipazione
Possono partecipare esclusivamente gli utenti registrati su raeinexchange.com. Il capitale minimo del conto in gara è di 500 €. Tutti i partecipanti devono operare con lo stesso broker indicato da RaeinExchange, in modo da garantire a tutti gli stessi parametri di confronto (spread, commissioni, leva ed esecuzione).

Art. 3 – Come partecipare
Per aderire l'utente deve contattare lo staff su Telegram (@poolefx) e completare le procedure indicate, comprese l'apertura o la verifica del conto presso il broker e la condivisione dei dati necessari al controllo delle performance. Completate le procedure, lo staff abilita l'account alla gara. Solo gli account abilitati compaiono in classifica.

Art. 4 – Periodo di gara
Ogni edizione dura un mese solare: inizia il primo giorno del mese alle ore 00:00 e termina l'ultimo giorno del mese alle ore 23:59 (ora italiana, Europe/Rome). Chi viene abilitato a mese iniziato partecipa dal momento dell'abilitazione.

Art. 5 – Calcolo della classifica
La classifica è ordinata per rendimento percentuale del mese, calcolato sul capitale presente all'inizio della gara. Accanto al rendimento è indicato il profitto in dollari. In caso di parità prevale il profitto in dollari più alto. I depositi e i prelievi effettuati durante il mese non vengono conteggiati come rendimento.

Art. 6 – Verifica e pubblicazione
Le performance sono verificate dallo staff RaeinExchange e pubblicate nella pagina Championship. Nella classifica pubblica il partecipante compare con nome e cognome in stampatello maiuscolo. La classifica diventa definitiva dopo la verifica di fine mese.

Art. 7 – Premi e consegna
I premi di ogni edizione sono pubblicati nella pagina Championship. I vincitori vengono contattati su Telegram e il premio viene consegnato entro 15 giorni dalla pubblicazione della classifica definitiva, dopo la verifica dell'identità del vincitore. I premi non sono convertibili né cedibili a terzi.

Art. 8 – Squalifica e comportamenti vietati
È vietato: partecipare con più account o con conti intestati a terzi; fornire dati falsi o alterati; usare tecniche di manipolazione, arbitraggio di latenza, hedging tra conti o sfruttare errori di quotazione del broker; accordarsi con altri partecipanti. In questi casi lo staff può squalificare il partecipante, anche a gara conclusa, e revocare il premio.

Art. 9 – Modifiche al regolamento
RaeinExchange può aggiornare il presente regolamento. Le modifiche valgono dall'edizione successiva alla loro pubblicazione. La partecipazione comporta l'accettazione integrale del regolamento.`;

const isHeading = (line) => /^(art\.?\s*\d+|articolo\s+\d+)/i.test(line.trim());

const Body = ({ text }) => (
  <div className="space-y-1">
    {text.split("\n").map((line, i) =>
      !line.trim() ? <div key={i} className="h-3" /> :
      isHeading(line) ? (
        <h3 key={i} className="pt-2 text-[13px] sm:text-sm font-bold uppercase tracking-wide text-white">{line.trim()}</h3>
      ) : (
        <p key={i} className="text-[13px] sm:text-sm leading-relaxed text-white text-justify">{line}</p>
      )
    )}
  </div>
);

export const RulesSheet = ({ text }) => (
  <section data-testid="cup-rules">
    <div className="flex items-center justify-between gap-4 mb-4 print:hidden">
      <div className="text-sm font-semibold text-white">Regolamento ufficiale</div>
      <button type="button" onClick={() => window.print()} data-testid="cup-rules-print-btn"
        className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-white/15 text-sm text-white hover:bg-white/5 transition-colors">
        <Printer size={15} /> Scarica / Stampa PDF
      </button>
    </div>
    <article id="cup-rules-sheet" data-testid="cup-rules-sheet"
      className="mx-auto max-w-[794px] bg-black text-white border border-white/10 shadow-2xl px-7 sm:px-14 pt-12 pb-8 flex flex-col min-h-[1000px]">
      <header className="text-center mb-8">
        <div className="text-[11px] tracking-[0.3em] uppercase text-white/70">Documento ufficiale</div>
        <h2 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight text-white">Regolamento Trading Cup</h2>
        <div className="mt-2 text-xs text-white/70">Campionato mensile di trading</div>
        <div className="mx-auto mt-6 h-px w-24 bg-blue-500" />
      </header>
      <div className="flex-1"><Body text={text || DEFAULT_RULES} /></div>
      <footer className="mt-12 flex flex-col items-center gap-1">
        <div className="flex items-center gap-2" data-testid="cup-rules-logo">
          <CandlestickChart size={26} className="text-blue-500" strokeWidth={2.5} />
          <span className="font-bold tracking-tight text-xl text-white">Raein<span className="text-blue-500">Exchange</span></span>
        </div>
        <div className="text-[10px] text-white/60">raeinexchange.com</div>
      </footer>
    </article>
  </section>
);
